module.exports = ".buttons-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin: 0px 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/eois/add-eoi/add-eoi.component.css
// module id = ./src/app/eois/add-eoi/add-eoi.component.css
// module chunks = main